/**
 * saveError.js - the server's reason for the last refused save, for screens
 * whose save call only returns true/false (updateProject is used that way in
 * many places). The KSA records API notes the message; the opportunity editor
 * takes it (once) and shows it instead of a generic "Could not save".
 */
let last = '';
export const noteSaveError = (msg) => {
  last = String(msg || '');
};
export const takeSaveError = () => {
  const m = last;
  last = '';
  return m;
};
